export function normalizeAppBasePath(value: string | undefined): string {
  const normalized = String(value || "").trim().replace(/^\/+|\/+$/g, "");
  return normalized ? `/${normalized}` : "";
}

export const APP_BASE_PATH = normalizeAppBasePath(import.meta.env.BASE_URL);

export function withAppBasePath(path: string, basePath = APP_BASE_PATH): string {
  const normalizedBasePath = normalizeAppBasePath(basePath);
  if (!normalizedBasePath || !path.startsWith("/") || path.startsWith("//")) return path;
  if (path === normalizedBasePath || path.startsWith(`${normalizedBasePath}/`)) return path;
  return `${normalizedBasePath}${path}`;
}
